import React, { useRef, useState } from "react";
import Socials from "../Socials/Socials";
import "./ContactDrawer.css";
import { IconContext } from "react-icons/lib";
import { BsGithub } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { socials } from "../../data";
import emailjs from "@emailjs/browser";
import { init } from "@emailjs/browser";
init(process.env.REACT_APP_USERID);

const styles = {
  icon: {
    size: "2rem",
  },
};

const ContactDrawer = () => {
  const form = useRef();
  const [message, setMessage] = useState();
  const [error, setError] = useState();

  const close = () => {
    let drawer = document.getElementsByClassName("contact-drawer")[0];

    drawer.classList.remove("contact-drawer--open-mobile");
    drawer.classList.remove("contact-drawer--open-desktop");
    drawer.classList.add("contact-drawer--close");
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICEID,
        process.env.REACT_APP_TEMPLATEID,
        form.current
      )
      .then(
        (result) => {
          setMessage("Message sent!");
          setTimeout(() => {
            setMessage(null);
          }, 10000);
        },
        (error) => {
          setError(error.text);
          setTimeout(() => {
            setError(null);
          }, 10000);
        }
      );
  };

  return (
    <div className="contact-drawer">
      <div className="contact-drawer--box-3">
        <button type="button" className="closeBtn" onClick={close}>
          &times;
        </button>
      </div>
      <div className="contact-drawer--box-2">
        <div>
          <h2 className="contact-drawer__heading h2">Contact Me</h2>
        </div>
        <div>
          <form ref={form} onSubmit={(e) => sendEmail(e)}>
            <div className="contact-drawer--box-1">
              <label htmlFor="name" className="contact-drawer__label body-1">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="contact-drawer__input"
              />
            </div>
            <div className="contact-drawer--box-1">
              <label htmlFor="email" className="contact-drawer__label body-1">
                Email Address
              </label>
              <input
                type="text"
                id="email"
                name="email"
                className="contact-drawer__input"
              />
            </div>
            <div className="contact-drawer--box-1">
              <label htmlFor="message" className="contact-drawer__label body-1">
                Message
              </label>
              <textarea
                type="text"
                id="message"
                name="message"
                className="contact-drawer__input body-1"
                rows="7"
                placeholder="How can I help?"
              />
            </div>
            <div className="contact-drawer--box-4">
              <button type="submit" className="contact-drawer__send body-1">
                Send
              </button>
            </div>
            {message && <div className="message-box body-1">{message}</div>}
            {error && <div className="error-box body-1">{error}</div>}
          </form>
          <div className="contact-drawer--box-5">
            <div className="contact-drawer--box-6">
              <a href={socials[0].url} target="_blank">
                <IconContext.Provider value={styles.icon}>
                  <BsGithub />
                </IconContext.Provider>
              </a>
            </div>
            <div>
              <a href={socials[1].url} target="_blank">
                <IconContext.Provider value={styles.icon}>
                  <BsLinkedin />
                </IconContext.Provider>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDrawer;
